import { Directive, OnInit, ComponentFactoryResolver, ViewContainerRef, Input } from '@angular/core';

@Directive({
    selector: '[appTabHolder]'
})
export class TabHolderDirective implements OnInit {

    @Input() appTabHolder;
    @Input() data;
    @Input() fullscreen;
    @Input() tabIndex;

    constructor(
        private componentFact: ComponentFactoryResolver,
        private vcRef: ViewContainerRef
    ) { }

    ngOnInit() {
        const componentFactory = this.componentFact.resolveComponentFactory(this.appTabHolder);
        const component = this.vcRef.createComponent(componentFactory);
        (component.instance as any).data = this.data;
        (component.instance as any).isFullscreen = this.fullscreen;
        (component.instance as any).isFullscreen = this.fullscreen;
        (component.instance as any).tabIndex = this.tabIndex;
    }
}
